import { useEffect, useRef } from 'react'
import { offlineSignal } from '@/features/offline-screen/signal'
import { fetcher } from 'src/api/fetcher'

export const healthFetcher = () => {
  return fetcher(
    { url: '/health', method: 'GET' },
    {
      __disableGlobalErrorToastFilters: [() => true],
    },
  )
}

let retryFn: (() => Promise<void>) | null = null

export const useNetworkWatcher = () => {
  const isChecking = useRef(false)

  if (!retryFn) {
    retryFn = async () => {
      if (isChecking.current) return
      isChecking.current = true
      try {
        await healthFetcher()
        offlineSignal.value = false
      } catch {
        offlineSignal.value = true
      } finally {
        isChecking.current = false
      }
    }
  }

  useEffect(() => {
    retryFn?.()

    const handleOnline = () => retryFn?.()

    const handleOffline = () => {
      offlineSignal.value = true
      retryFn?.()
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    const interval = setInterval(() => {
      if (offlineSignal.value) retryFn?.()
    }, 5000)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      clearInterval(interval)
    }
  }, [])

  return { retry: retryFn }
}
